import IconContainer from '@/components/IconContainer'

export default function IconChevronDown(props) {
  return (
    <IconContainer
      {...props}
      width="10"
      height="10"
      ariaLabel="Chevron Down Icon"
      stroke="currentColor"
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        d="M8.63357 3.54187L5.09803 7.07741L1.5625 3.54187"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.23105 3.21041C1.41411 3.02736 1.71091 3.02736 1.89397 3.21041L5.09804 6.41449L8.30212 3.21041C8.48518 3.02736 8.78198 3.02736 8.96503 3.21041C9.14809 3.39347 9.14809 3.69027 8.96503 3.87333L5.09804 7.74032L1.23105 3.87333C1.048 3.69027 1.048 3.39347 1.23105 3.21041Z"
      />
    </IconContainer>
  )
}
